import { useEffect, useState } from "react";

import { locationApi } from "../services";
import type { LocationTypedAddress } from "../types";

export function useContactAddresses(
  contactId: number | null | undefined,
): LocationTypedAddress[] {
  const [fetchedAddresses, setFetchedAddresses] = useState<
    LocationTypedAddress[]
  >([]);

  useEffect(() => {
    if (!contactId) {
      return;
    }

    const controller = new AbortController();

    locationApi
      .fetchContactAddresses(contactId, { signal: controller.signal })
      .then(setFetchedAddresses)
      .catch(() => {});

    return () => controller.abort();
  }, [contactId]);

  return contactId ? fetchedAddresses : [];
}
